<template>
  <div class="join-ent" v-if="visible">
    <ent-info-form :visible="showEntInfoForm"
                   @submit="handleNext"
                   @confirm="handleConfirm"
                   @close="handleClose"/>
    <recommend-list :visible="showRecommendList"
                    :products="products"
                    @create="handleCreate"
                    @binding-account="handleBindingAccount"
                    @submit="handleSelect"
                    @close="handleClose"/>
    <binding-account :visible="showBindingAccount"
                     :account="productInfo.account"
                     @previous="handlePrevious"
                     @success="handleJoinedSuccess"
                     @close="handleClose"/>
    <joined-success :visible="showJoinedSuccess"
                    @login="handleLogin"
                    @close="handleClose"/>
  </div>
</template>

<script>
import JsEncrypt from 'jsencrypt'
import EntInfoForm from './EntInfoForm'
import RecommendList from './RecommendList'
import BindingAccount from './BindingAccount'
import JoinedSuccess from './JoinedSuccess'
import {
  getRecommendList,
  createEmployee,
  bindingAccount,
  bindingGarbageAccount,
  bindingAsset
} from '@/assets/service/invitation'

// rsa加密
const encrypt = new JsEncrypt()
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDd9v+OVxa5ituKgpeyUVHG6oLd15HJsI6UHj7ZcQsrGTJGzA+Gv0LkPwnHBxyqXnaY8gY98KVBGCE/3gfejdT8a9Wx7n7Iu1xPE35WnYzSZ/TuDVzK3bU8HV/EiiVPXEzJQmhmHMwMzUOJJ3+jGkafad/BVs8Pysxdd3uUWkInuQIDAQAB'
encrypt.setPublicKey(publicKey)

export default {
  name: 'JoinEnt',
  components: {
    EntInfoForm,
    RecommendList,
    BindingAccount,
    JoinedSuccess
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler (value) {
        this.showEntInfoForm = value
        document.body.style.overflow = (value ? 'hidden' : 'auto')
      },
      immediate: true
    }
  },
  data () {
    return {
      showEntInfoForm: false,
      showRecommendList: false,
      showBindingAccount: false,
      showJoinedSuccess: false,
      enterpriseInfo: {},
      products: [
        // {
        //   'id': 1,
        //   'account': 'GLD18259403404@xf858',
        //   'userId': '6927417293250846900',
        //   'assetNum': null,
        //   'productUsedVos': [{'productName': '企业清单模板库', 'endDate': 1682681450000}, {'productName': '企业基准价格库', 'endDate': 1682681450000}, {'productName': '成本指标应用平台', 'endDate': 1682681450000}, {'productName': '成本指标应用平台', 'endDate': 1682681450000}],
        //   'type': 1
        // },
        // {
        //   'id': 2,
        //   'account': 'yg03@xf858',
        //   'userId': '6924318832841257393',
        //   'assetNum': null,
        //   'productUsedVos': [{'productName': '成本指标应用平台', 'endDate': 1682681369000}],
        //   'type': 1
        // },
        // {
        //   'id': 3,
        //   'account': 'GLD18259403404_01@xf858',
        //   'userId': '6927419485733675088',
        //   'assetNum': null,
        //   'productUsedVos': [],
        //   'type': 1
        // },
        // {
        //   'id': 4,
        //   'account': null,
        //   'userId': null,
        //   'assetNum': 'YSZZ8001072921',
        //   'productUsedVos': [{'productName': '成本指标应用平台', 'endDate': 1682681262000}],
        //   'type': 2
        // },
        // {
        //   'id': 5,
        //   'account': null,
        //   'userId': null,
        //   'assetNum': 'YSZZ8001078408',
        //   'productUsedVos': [{'productName': '成本指标应用平台', 'endDate': 1682681437000}],
        //   'type': 2
        // },
        // {
        //   'id': 6,
        //   'account': 'yg01@xf858',
        //   'userId': '6924318833035342382',
        //   'assetNum': null,
        //   'productUsedVos': [{'productName': '成本指标应用平台', 'endDate': 1682681379000}],
        //   'type': 4
        // },
        // {
        //   'id': 7,
        //   'account': 'yg02@xf858',
        //   'userId': '6924318833064128903',
        //   'assetNum': null,
        //   'productUsedVos': [{'productName': '成本指标应用平台', 'endDate': 1682681262000}],
        //   'type': 4
        // }
      ],
      productInfo: {},
      rules: {
        username: [{
          required: true, message: '账号不能为空'
        }],
        password: [{
          required: true, message: '密码不能为空'
        }]
      }
    }
  },
  methods: {
    // 关闭弹窗
    handleClose () {
      this.productInfo = {}
      this.showEntInfoForm = true
      this.showRecommendList = false
      this.showBindingAccount = false
      this.showJoinedSuccess = false
      this.$emit('changeJoinShow', false)
    },
    // 下一步
    handleNext (enterpriseInfo) {
      Object.assign(this.enterpriseInfo, enterpriseInfo)
      // this.showEntInfoForm = false
      // this.showRecommendList = true
      getRecommendList(enterpriseInfo).then(res => {
        const {code, message, data} = res
        switch (code) {
          case 200:
            this.showEntInfoForm = false
            // 显示推荐列表
            if (Array.isArray(data) && data.length) {
              this.showRecommendList = true
              this.products = data || []
            } else {
              // 推荐列表为空时，显示确认弹窗
              this.emptyEmployeeInfo()
            }
            break
          case 330025:
            // 已加入企业
            this.showEntInfoForm = false
            this.handleConfirm()
            break
          case 320010:
            // 未命中CRM联系人信息，自动创建账号
            this.showEntInfoForm = false
            this.showJoinedSuccess = true
            break
          default:
            message && this.$message.error(message)
        }
      }).catch(e => this.$message.error(e.message))
    },
    // 推荐列表为空时，显示确认弹窗
    emptyEmployeeInfo () {
      this.$confirm({
        message: '该手机号暂未加入企业',
        customClass: 'custom-confirm-position',
        width: 400,
        multipleSubmit: [
          {type: 'minor', name: '绑定已有账号', key: 'value', value: 1},
          {type: 'primary', name: '创建新账号', key: 'value', value: 0}
        ],
        noCancelBtn: true,
        bodyStyle: {},
        footerStyle: {},
        submit: (data) => {
          if (data.value) {
            this.handleBindingAccount()
          } else {
            this.handleCreate()
          }
        }
      })
    },
    // 上一步
    handlePrevious () {
      this.showBindingAccount = false
      if (Array.isArray(this.products) && this.products.length) {
        this.showRecommendList = true
      } else {
        this.emptyEmployeeInfo()
      }
    },
    // 创建新账号
    handleCreate () {
      // API 直接调用创建接口
      const {enterpriseId, mobile, shareKey} = this.enterpriseInfo
      createEmployee({enterpriseId, mobile, shareKey}).then(res => {
        const {code, message} = res
        if (code === 200) {
          this.showRecommendList = false
          this.showJoinedSuccess = true
        } else if (code === 330025) {
          this.showRecommendList = false
          this.handleConfirm()
        } else {
          message && this.$message.error(message)
        }
      }).catch(e => this.$message.error(e.message))
    },
    // 已加入企业弹窗
    handleConfirm () {
      this.$confirm({
        message: '您已加入此企业，是否直接登录？',
        customClass: 'custom-confirm-position',
        width: 400,
        multipleSubmit: [
          {type: 'minor', name: '取消', key: 'value', value: 0},
          {type: 'primary', name: '确定', key: 'value', value: 1}
        ],
        noCancelBtn: true,
        bodyStyle: {},
        footerStyle: {},
        submit: (data) => {
          if (data.value) {
            this.handleLogin()
          } else {
            this.handleClose()
          }
        }
      })
    },
    // 绑定已有账号
    handleBindingAccount () {
      this.productInfo = {}
      this.showRecommendList = false
      this.showBindingAccount = true
    },
    // 使用预选账号
    handleSelect (productInfo) {
      const {type, userId, assetNum} = productInfo
      const {enterpriseId, mobile} = this.enterpriseInfo
      // 云端授权对应分配的未实名员工账号
      if (type === 1) {
        this.productInfo = productInfo
        this.showRecommendList = false
        this.showBindingAccount = true
      } else if (type === 2) {
        // 未分配的云端授权
        this.bindingAsset({assetNum, enterpriseId, mobile})
      } else {
        // 绑定垃圾账号，直接绑定，绑定成功后使用手机号登录
        this.garbageAccount({gldUserId: userId, enterpriseId, mobile})
      }
    },
    // 请求-绑定垃圾账号
    garbageAccount (params) {
      bindingGarbageAccount(params).then(this.bindingCallback).catch(e => this.$message.error(e.message))
    },
    // 请求-绑定未分配的云端授权
    bindingAsset (params) {
      bindingAsset(params).then(this.bindingCallback).catch(e => this.$message.error(e.message))
    },
    // 绑定账号回调函数
    bindingCallback (res) {
      const {code, message} = res
      if (code === 200) {
        this.showRecommendList = false
        this.showJoinedSuccess = true
      } else if (code === 330025) {
        // 已加入企业
        this.showRecommendList = false
        this.handleConfirm()
      } else {
        message && this.$message.error(message)
      }
    },
    // 加入成功
    handleJoinedSuccess ({account, password}) {
      const {enterpriseId, mobile} = this.enterpriseInfo
      bindingAccount({enterpriseId, mobile, account, password: encrypt.encrypt(password)}).then(res => {
        const {code, message} = res
        if (code === 200) {
          this.showBindingAccount = false
          this.showJoinedSuccess = true
        } else if (code === 10000) {
          this.$message.error('请输入本企业内员工账号')
        } else {
          message && this.$message.error(message)
        }
      }).catch(e => this.$message.error(e.message))
    },
    // 去登录
    handleLogin () {
      this.sentLog(100117105)
      this.handleClose()
      this.$emit('login', true)
    }
  }
}
</script>

<style>
  .ent-explain-text {
    height: 36px;
    padding: 8px 12px;
    box-sizing: border-box;
    background: #FFFBDA;
    border: 1px solid #ECDBA5;
    font-size: 12px;
    font-weight: 400;
    color: rgba(33, 37, 48, 0.8);
    line-height: 20px;
    margin-bottom: 16px;
  }

  @media only screen and (min-width: 1440px) {
    .custom-confirm-position {
      top: 386px;
    }
  }
</style>
